import type { UploadMedia201Metadata } from './uploadMedia201Metadata';
import type { UploadMedia201Type } from './uploadMedia201Type';

export type UploadMedia201 = {
  /** 접근성을 위한 대체 텍스트 */
  altText?: string;
  /** Minio 버킷 이름 (파일인 경우) */
  bucketName?: string;
  /** 파일 MIME 타입 (파일인 경우) */
  contentType?: string;
  /** 미디어에 대한 설명 */
  description?: string;
  /** 비디오/오디오 재생 시간 (초) */
  duration?: number;
  /** 원본 파일명 (파일인 경우) */
  fileName?: string;
  /** 파일 크기 (바이트) */
  fileSize?: number;
  /** 이미지/비디오 높이 */
  height?: number;
  /** 미디어 파일 ID */
  id?: number;
  /** 추가 메타데이터 */
  metadata?: UploadMedia201Metadata;
  /** Minio 객체 경로 (파일인 경우) */
  objectPath?: string;
  /** 스트리밍 가능 여부 (비디오인 경우) */
  streamingAvailable?: boolean;
  /** 썸네일 이미지 URL (비디오/GIF인 경우) */
  thumbnailUrl?: string;
  /** 미디어 유형 */
  type?: UploadMedia201Type;
  /** 업로드 일시 */
  uploaded?: string;
  /** 미디어 파일 접근 URL 또는 외부 링크 */
  url?: string;
  /** 이미지/비디오 너비 */
  width?: number;
};
